export default __webpack_public_path__ + "assets/img/1R8ZIe9.svg";